import React, { useContext, useState } from "react";
import "../../SelectExposures/ExposuresAnalysis/ExposuresAnalysis.css";

export default function PlayerSelectAnalysis(props) {
  let posBreakdowns = {};

  for (const [pos, posData] of Object.entries(props.positions)) {
    const players = props.players.filter((player) =>
      player.rosterSlots.edges
        .map((edge) => {
          return edge.node.name;
        })
        .some((item) => {
          return item === pos;
        })
    );

    if (!(pos in posBreakdowns)) posBreakdowns[pos] = 0;

    posBreakdowns[pos] = players.length;
  }

  const positionAnalysisElements = Object.keys(posBreakdowns).map((key) => {
    return (
      <div
        key={key}
        className={"exposures-analysis-position"}
        style={{ textAlign: "left", padding: "0 15px 0 0" }}
      >
        <div>
          <strong>{key}</strong>
        </div>
        <div>{posBreakdowns[key]} players</div>
        <br />
      </div>
    );
  });

  return (
    <div className="exposures-analysis">
      <div
        className="exposures-analysis-breakdown"
        style={{ justifyContent: "left", padding: 0 }}
      >
        {positionAnalysisElements}
      </div>
    </div>
  );
}
